import { PropsWithChildren, useEffect } from "react";

interface ScrollLockProps {
  isActive: boolean;
}

/**
 * If active, hides scrollbar and prevents scrolling
 */
const ScrollLock = ({ isActive, children }: PropsWithChildren<ScrollLockProps>) => {
  useEffect(() => {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

    if (isActive) {
      document.body.style.overflow = "hidden";
      if (scrollbarWidth > 0) {
        document.body.style.paddingRight = `${scrollbarWidth}px`;
      }
    } else {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    }

    return () => {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    };
  }, [isActive]);

  return <>{children}</>;
};

export default ScrollLock;
